import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CardScreen from './screens/CardScreen';
import SigninScreen from './screens/SigninScreen';
import ShippingAddressScreen from './screens/ShippingAddressScreen';
import SignupScreen from './screens/SignupScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import ProfileScreen from './screens/ProfileScreen';
import SearchScreen from './screens/SearchScreen';
import Footer from './components/Footer';
import AboutUs from './screens/AboutUs';
import Home from './screens/Home';
import Fabric from './screens/Fabric';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import DashboardScreen from './screens/DashboardScreen';
import ProductListScreen from './admin screen/ProductListScreen';
import ProductEditScreen from './admin screen/ProductEditScreen';
import OrderListScreen from './admin screen/OrderListScreen';
import ContactUs from './screens/ContactUs';
import FabricListScreen from './admin screen/FabricListScreen';
import FabricEditScreen from './admin screen/FabricEditScreen';
import Careers from './screens/Careers';
import { FiArrowUp } from 'react-icons/fi';
import { assets } from '../src/assets/assets';
import { useState, useEffect } from 'react';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="app-container">
        <Routes>
          <Route path="/product/:slug" element={<ProductScreen />} />
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/product" element={<HomeScreen />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/fabrics" element={<Fabric />} />
          <Route path="/cart" element={<CardScreen />} />
          <Route path="/signin" element={<SigninScreen />} />
          <Route path="/shaw" element={<SignupScreen />} />
          <Route path="/shipping" element={<ShippingAddressScreen />} />
          <Route path="/placeorder" element={<PlaceOrderScreen />} />
          <Route path="/order/:id" element={<OrderScreen />} />
          <Route path="/products" element={<SearchScreen />} />
          <Route path="/career" element={<Careers />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfileScreen />
              </ProtectedRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <AdminRoute>
                <DashboardScreen />
              </AdminRoute>
            }
          ></Route>
          <Route
            path="/admin/products"
            element={
              <AdminRoute>
                <ProductListScreen />
              </AdminRoute>
            }
          ></Route>
          <Route
            path="/admin/product/:id"
            element={
              <AdminRoute>
                <ProductEditScreen />
              </AdminRoute>
            }
          ></Route>
          <Route
            path="/admin/orders"
            element={
              <AdminRoute>
                <OrderListScreen />
              </AdminRoute>
            }
          ></Route>
          <Route
            path="/admin/fabrics"
            element={
              <AdminRoute>
                <FabricListScreen />
              </AdminRoute>
            }
          ></Route>
          <Route
            path="/admin/fabric/:id"
            element={
              <AdminRoute>
                <FabricEditScreen />
              </AdminRoute>
            }
          ></Route>
        </Routes>

        {/* Floating Buttons */}
        <div className="floating-buttons">
          {/* WhatsApp Floating Button */}
          <a
            href="https://wa.me/94703533536"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-button"
          >
            <img
              src={assets.whatsapp_logo}
              alt="WhatsApp Chat"
              className="whatsapp-logo"
            />
          </a>

          {/* Scroll to Top Button - Only shows when scrolled down */}
          {showScrollButton && (
            <button
              onClick={scrollToTop}
              className="scroll-to-top"
              title="Go to top"
            >
              <FiArrowUp />
            </button>
          )}
        </div>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
